import {defPDFHeader} from "../../../partsOfPage";
import {Content} from "pdfmake/interfaces";
import {getSideShelvingSystem} from "../../../partsOfPage/getSideShelvingSystem";
import {ScreenshotCanvasView} from "../../../types";
import {StoreWallInterface} from "../../../../../store/types/store";


export const getSideShelvingSystemPage = (shelving: StoreWallInterface, view: ScreenshotCanvasView): Array<Content> => {
    const page: Array<Content> = [];
    page.push(JSON.parse(JSON.stringify(defPDFHeader)));
    page.push(getSideShelvingSystem(shelving, view))
    return page
}
